module.exports = __webpack_public_path__ + "static/media/Filters_MainFuelFilter_Xparent.55c07f79.png";